import { get } from '../../utility/Requests';

export const leaseUrl = '/api/license/accountant/Lease';

export function getAvailableTenantLeasesCount(): Promise<number> {
    return get<number>(leaseUrl);
}
